import { POSTURE_CONDITION_LEVEL } from '@/pages/ai-consultation/components/posture-condition-level';
import { POSTURE_ADJUST_ITEM_2_TEXT } from '@/pages/ai-consultation/components/posture-condition';

import cx from './index.module.scss';

interface BodyAdjustItemProps {
  name: string;
  value?: number;
  onChange?: (value: number) => void;
}

const BodyAdjustItem = (props: BodyAdjustItemProps) => {
  const { value, name, onChange } = props;

  return (
    <div className={cx('item')}>
      <div className={cx('name')}>{POSTURE_ADJUST_ITEM_2_TEXT[name]}</div>
      <div className={cx('level-wrapper')}>
        {POSTURE_CONDITION_LEVEL?.map(item => (
          <div
            onClick={() => onChange(item?.level)}
            className={cx('selector-item', { active: value === item?.level })}
            key={item?.name}
          >
            <div className={cx('name')}>{item.name}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BodyAdjustItem;
